import React from 'react';

import Thumb from '../img/blogs/javascript-data-structures.jpg';

const JavaScriptDataStructure = {
    id: 14, permalink: "javascript-data-structures", thumb: Thumb, postBy: "Wasek Bellah", postDate: "May 08, 2020", categories: "JavaScript, Data Structures", title: "JavaScript- Data Structures", shortDesc: "A Data Structure is a specific strategy for organizing and storing data so that we can access and modify it efficiently.", fullDesc: <>
        <h2>Data Structure</h2>
        <p>A Data Structure is a specific strategy for organizing and storing data so that we can access and modify it efficiently. More precisely, It is a <strong>collection of data values, the relationships between them</strong>, and the <strong>functions or operations</strong> that we can apply to the <strong>data</strong>.</p>

        <p><em>Now We will be talking about 5 <strong>Data Structures</strong></em>:</p>
        <ul>
            <li>Stack</li>
            <li>Queue</li>
            <li>Linked list</li>
            <li>Hash table</li>
            <li>Trees</li>
        </ul>


        <h2>Stack</h2>
        <p>The <strong>Stack</strong> is a primary <strong>Data Structure</strong>, these referred to as the <strong>last item in</strong>, the <strong>first item out</strong> (<strong>LIFO</strong>). The last item added into the stack will be the first one taken out of the stack.</p>

        <p><strong>Stacks</strong> are basically <strong>arrays</strong> where we can only thing do, more or less, is to push and pop.</p>

        <h4>Basic Syntax:</h4>
        <pre className="code">
            class Stack &#123; <br />
                &nbsp; constructor() &#123; <br />
                    &nbsp;   &#47;&#47; create stack, which is an empty object <br />
                    &nbsp;   this.stack = &#123;&#125; <br />
                &nbsp; &#125; <br />
                &nbsp; push(value) &#123; &#125; <br />
                &nbsp; pop() &#123; &#125; <br />
                &nbsp; peek() &#123; &#125; <br />
            &#125;
        </pre>


        <h2>Interface of Stack</h2>
        <p>Let's look at the interface of building a <strong>Stack</strong>.</p>
        <ul>
            <li>1. Constructor Function
                <ul>
                    <li>i) Storage <br />
                    &nbsp; <small><strong>Storage</strong> is a variable, where we are trying to put something into our <strong>stack</strong>.</small></li>
                </ul>
            </li>
            <li>1. Methods
                <ul>
                    <li>i) <code>push(element)</code> <br />
                    &nbsp; <small><code>push()</code> adds an element to the <strong>stack</strong>.</small></li>

                    <li>ii) <code>pop()</code> <br />
                    &nbsp; <small><code>pop()</code> removes and returns the last element of the <strong>stack</strong>.</small></li>

                    <li>iii) <code>peek()</code> <br />
                    &nbsp; <small><code>peek()</code> returns the last element of the <strong>stack</strong>.</small></li>

                    <li>iv) <code>size()</code> <br />
                    &nbsp; <small><code>size()</code> returns an integer with the size of the <strong>stack</strong>.</small></li>
                </ul>
            </li>
        </ul>


        <h2>Queue</h2>
        <p><strong>Queues</strong> are, the first item added to the <strong>queue</strong> will be the first one, these referred to as the <strong>first item in</strong>, the <strong>first item out</strong> (<strong>FIFO</strong>). When adding an item into the <strong>queue</strong> that operation is called <strong>enqueuing</strong> and when take out an item from the <strong>queue</strong> the operation is called <strong>dequeuing</strong>.</p>

        <h4>Basic Syntax:</h4>
        <pre className="code">
            class Queue &#123; <br />
                &nbsp; constructor() &#123; <br />
                    &nbsp;   &#47;&#47; array to hold values <br />
                    &nbsp;   this.queue = []; <br />
                    &nbsp;   this.length = 0; <br />
                &nbsp; &#125; <br />
                &nbsp; enqueue(value) &#123; &#125; <br />
                &nbsp; dequeue() &#123; &#125; <br />
                &nbsp; peek() &#123; &#125; <br />
            &#125;
        </pre>


        <h2>Interface of Queue</h2>
        <p>Let's look at the interface of building a <strong>Queue</strong>.</p>
        <ul>
            <li>1. Constructor Function
                <ul>
                    <li>i) Storage <br />
                    &nbsp; <small><strong>Storage</strong> is a variable, where we are trying to put something into our <strong>queue</strong>.</small></li>
                </ul>
            </li>
            <li>1. Methods
                <ul>
                    <li>i) <code>enqueue(value)</code> <br />
                    &nbsp; <small><code>enqueue()</code> adds a value to the <strong>queue</strong> returns to size.</small></li>

                    <li>ii) <code>dequeue()</code> <br />
                    &nbsp; <small><code>dequeue()</code> removes a value from the <strong>queue</strong>, returns the value.</small></li>

                    <li>iii) <code>size()</code> <br />
                    &nbsp; <small><code>size()</code> returns the size of the <strong>queue</strong> as an integer.</small></li>

                    <li>iv) <code>contains(value)</code> <br />
                    &nbsp; <small><code>contains()</code> returns true or false whether the value exists or not in the <strong>queue</strong>.</small></li>
                </ul>
            </li>
        </ul>


        <h2>Linked List</h2>
        <p>A <strong>linked list</strong> is an ordered collection of data elements. A data element in a <strong>linked list</strong> can be represented as a <strong>node</strong>. Each node has two parts: <strong>data</strong> and <strong>pointer</strong> to the next <strong>node</strong>.</p>

        <p>Unlike <strong>arrays</strong>, data elements are not stored in consistent locations. Data elements or <strong>nodes</strong> are linked using pointers. So, it's called a <strong>linked list</strong>.</p>

        <pre className="code">
            const list = &#123; <br />
                &nbsp; head: &#123; <br />
                    &nbsp;   value: 25, <br />
                    &nbsp;   next: &#123; <br />
                        &nbsp;     value: 86, <br />
                        &nbsp;     next: &#123; <br />
                            &nbsp;       value: 49, <br />
                            &nbsp;       next: null <br />
                        &nbsp;     &#125; <br />
                    &nbsp;   &#125; <br />
                &nbsp; &#125; <br />
            &#125;; <br />
            console.log(list.head.next.value);
        </pre>
        <p><strong>Expected output:</strong> <code class="output">86</code></p>


        <h2>Hash Table</h2>
        <p>A <strong>hash table</strong> is a <strong>data structure</strong> that <strong>pairs keys to values</strong>. It's the technique of converting a range of key techniques to the range of an <strong>array</strong> index. It implements an associative <strong>array</strong>, which means it <strong>maps keys to values</strong>. A <strong>JavaScript object</strong> is a <strong>hash table</strong> because it stores <strong>key-value pairs</strong>.</p>

        <p>A <strong>hash table</strong> uses a <strong>hash function</strong> to calculate an index in an array, from which the desired value is obtained.</p>

        <p><em>The <strong>hash table</strong> operations are performed in two steps</em>:</p>
        <ul>
            <li>A <code>key</code> is converted to an <code>integer index</code> using a <strong>hash function</strong>.</li>
            <li>This <code>index</code> decides what <code>key-value</code> pairs are included in the record.</li>
        </ul>


        <h2>Components of a hash table</h2>
        <p><em>A basic <strong>hash table</strong> consists of two parts</em>:</p>
        <ul>
            <li>Hash function</li>
            <li>Array</li>
        </ul>

        <h3>Hash function</h3>
        <p>As we have already seen, the <strong>hash function</strong> determines the index of our <code>key-value</code> pairs. Selecting an efficient <strong>hash function</strong> is an important part of creating a good <strong>hash table</strong>. It is a <strong>one-way function</strong>, meaning that the <code>key</code> cannot be restored from the <strong>hash</strong>. To choose a good <strong>hash function</strong>, we have to avoid generating the same <strong>hash</strong> for different <code>keys</code>.</p>

        <h3>Array</h3>
        <p>The <strong>array</strong> contains all <code>key-value</code> entries in the <strong>table</strong>. The size of the <strong>array</strong> should be set according to the expected amount of data.</p>


        <h2>Trees <span role="img" aria-label="tree">🌳</span></h2>
        <p><strong>Trees data structures</strong> are related to <strong>relationships</strong>, which specializes in presenting classified structures. This <strong>data structure's</strong> node can have zero or more children. Each node contains a <strong>value</strong>.</p>

        <p>Each <strong>tree</strong> has a <strong>"root" node</strong>, outside of which all other <strong>nodes</strong> have branches. The <strong>root</strong> contains a reference to all the elements directly below it, known as its <strong>"child nodes"</strong>. With each <strong>child node</strong>, more <strong>child nodes</strong> continue to branch out.</p>


        <h2>A Simple Tree Data Structure</h2>
        <p>A <strong>tree node</strong> is just a <strong>data structure</strong> that has a value and has links to their <strong>descendants</strong>.</p>

        <pre className="code">
            class TreeNode &#123; <br />
                &nbsp; constructor(value) &#123; <br />
                    &nbsp;   this.value = value; <br />
                    &nbsp;   this.descendants = []; <br />
                &nbsp; &#125; <br />
            &#125; <br /><br />

            const home = new TreeNode('Home'); <br />
            const firstChild = new TreeNode('First Child'); <br />
            const secondChild1 = new TreeNode('Second Child 1'); <br />
            const secondChild2 = new TreeNode('Second Child 2'); <br />
            const thirdChild = new TreeNode('Third Child'); <br /><br />

            home.descendants.push(firstChild); <br />
            firstChild.descendants.push(secondChild1, secondChild2); <br />
            secondChild1.descendants.push(thirdChild);
        </pre>

        <p>Now We have a <strong>tree data structure</strong>.</p>
        <p>The <strong>node</strong> <code>home</code> is the root and <code>secondChild1, secondChild2, thirdChild</code> are the leaf nodes of the <strong>tree</strong>.</p>
    </>
};
export default JavaScriptDataStructure;